<ng-container *ngFor="let address of locations">
	<span class="phone-icon hq mr-2"
		  *ngIf="address.is_ushq && address.phones?.length"
		  [matTooltip]="isOpened ? '' : 'We have a head quarter phone number for this company'" matTooltipPosition="after">
	</span>
</ng-container>
<a class="linkedin-icon mr-2" *ngIf="linkedinUrl"
   [matTooltip]="isOpened ? '' : 'Click to open the LinkedIn profile of this company'"
   matTooltipPosition="after" target="_blank"
   [attr.href]="linkedinUrl | formatUrl">
</a>
<a class="www-icon mr-2" *ngIf="primaryDomain"
   [matTooltip]="primaryDomain" matTooltipPosition="after"
   target="_blank" href="http://{{primaryDomain}}">
</a>
<span
	class="inline-flex items-center justify-center w-5 h-[15px] align-middle text-primary-light"
	*ngIf="purchaseHistory | purchaseHistory"
	[matTooltip]="isOpened ? '' : 'This company is already revealed or exported by you or one of your team members'"
	matTooltipPosition="after"
>
	<fa-icon aria-hidden="true" class="si-icon relative -left-px text-[15px] py-0" [icon]="['fas', 'eye']"></fa-icon>
</span>
